import { useDispatch } from "react-redux";

import {
  PORCENTAJE_DEV_EXCLUIDO,
  SUMA_ASEGURADA_EXCLUIDA,
  TIEMPO_AHORRO_EXCLUIDO,
} from "@/utils/awsConfig";
import {
  deleteDuplicateObject,
  formatAmountThousand,
  formatExactSelect,
  removeItemsArrayFromArray,
} from "@/utils/Utils";
import { changeGlobalState } from "@/redux/actions/global";
import { API_CANAL } from "@/utils/consts";
import HTTP_REQUEST from "@/utils/http";
import url from "@/utils/url";
import helpers from "@/utils/helpers";
import { PLANS_FINISH, PLANS_START, PLANS_SUCCESS } from "@/redux/types/plans";
import { decryptCredentials } from "@/utils/cifrate";

export const usePlanService = () => {
  const LIMIT_PERMANENCY_AGE = 77; /* Edad máxima de permanencia en el seguro */
  const dispatch = useDispatch();

  const getAttribute = async (request, type, clientAge) => {
    const applyFilter = localStorage.getItem("origen_venta") !== "webcall";

    try {
      const {
        response: { payload, status },
      } = await HTTP_REQUEST.postWitchTrace(
        url.obtenerAtributoValor,
        request,
        "APIS_VCT",
        API_CANAL
      );
      if (status.success) {
        let attributeFormated;
        switch (type) {
          case "sumAssured":
            let itemsSumAssured = payload.payload;
            if (applyFilter) {
              itemsSumAssured = removeItemsArrayFromArray(
                itemsSumAssured,
                SUMA_ASEGURADA_EXCLUIDA,
                "dscValor"
              );
            }
            attributeFormated = formatExactSelect(itemsSumAssured, {
              value: "ideValor",
              text: "dscValor",
            });
            attributeFormated.map(
              (item) => (item.text = `S/${formatAmountThousand(item.text)}`)
            );
            break;
          case "savingTime":
            let itemsSavingTime = payload.payload;
            if (applyFilter) {
              itemsSavingTime = removeItemsArrayFromArray(
                itemsSavingTime,
                TIEMPO_AHORRO_EXCLUIDO,
                "valor"
              );
            }
            attributeFormated = formatExactSelect(itemsSavingTime, {
              value: "ideValor",
              text: "valor",
            });
            const limitSavingTime = LIMIT_PERMANENCY_AGE - (clientAge || 0);
            const savingTimeValues = attributeFormated.filter(
              (e) => e.text <= limitSavingTime
            );
            attributeFormated = savingTimeValues;
            attributeFormated.map((item) => (item.text = `${item.text}`));
            break;
          case "returnPercentage":
            let itemsReturnPercentage = payload;
            if (applyFilter) {
              const resultFilterDuplicate = deleteDuplicateObject(
                itemsReturnPercentage,
                "dscValor"
              );
              itemsReturnPercentage = removeItemsArrayFromArray(
                resultFilterDuplicate,
                PORCENTAJE_DEV_EXCLUIDO,
                "dscValor"
              );
            }
            attributeFormated = formatExactSelect(itemsReturnPercentage, {
              value: "ideValor",
              text: "dscValor",
            });
            attributeFormated.sort((a, b) => Number(a.text) - Number(b.text));
            attributeFormated.map((item) => (item.text = `${item.text}%`));
            break;
          default:
            break;
        }
        return deleteDuplicateObject(attributeFormated, "text");
      } else {
        dispatch(changeGlobalState(4));
      }
    } catch (error) {
      dispatch(changeGlobalState(4));
      helpers.sendTagError(error, url.obtenerAtributoValor);
    }
  };

  const createQuote = async (request) => {
    dispatch({ type: PLANS_START });
    try {
      const plans = await HTTP_REQUEST.postWitchTrace(
        url.obtenerPlanes,
        request,
        "APIS_VCT",
        API_CANAL
      );
      const { payload, status } = plans.response;
      if (status.success) {
        const sortPlans = payload.sort((planA, planB) => {
          return planA.plan.aniosPlan - planB.plan.aniosPlan;
        });
        dispatch({
          type: PLANS_SUCCESS,
          data: sortPlans,
        });
      } else {
        dispatch(changeGlobalState(4));
      }
      return payload;
    } catch (error) {
      const currentError = error?.response?.data?.response?.status?.error;
      helpers.sendTagError(error, url.obtenerPlanes);
      if (currentError?.code) {
        helpers.getTagError(
          currentError?.code,
          "Problema técnico cotización",
          "trackError"
        )
      }
    } finally {
      dispatch({
        type: PLANS_FINISH,
      });
    }
  };

  const selectQuote = async (request) => {
    try {
      const { response } = await HTTP_REQUEST.postWitchTrace(
        url.seleccionarPlan,
        request,
        "APIS_VCT",
        API_CANAL
      );
      if (response.status) {
        return response;
      } else {
        dispatch(changeGlobalState(4));
      }
    } catch (error) {
      dispatch(changeGlobalState(4));
      helpers.sendTagError(error, url.seleccionarPlan);
    }
  };

  const downloadQuote = async (request) => {    
    const bodyRequest = helpers.getBodySimpleWithTrace(request, helpers.getLeadsTrace(API_CANAL));
    bodyRequest.headers = { 'x-api-key': decryptCredentials(process.env.REACT_APP_API_KEY_CROSS_CANAL) };

    return await HTTP_REQUEST.AmplifyApi({
      name: "CANAL_CROSS",
      path: url.downloadQuote,
      data: bodyRequest,
    });
  };

  return {
    getAttribute,
    createQuote,
    selectQuote,
    downloadQuote,
  };
};
